import type { InternalRefetchQueryDescriptor } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import { useCallback, useState } from 'react';

import { BASE_DATE } from '~/constants/organization_notification';
import {
  GetUnreadMedicationFollowupQuestionnaireSheetsDocument,
  MarkMedicationFollowupQuestionnaireSheetDocument,
} from '~/graphql/generated/graphql';

export const useViewSheet = (refetchQueries?: InternalRefetchQueryDescriptor[]) => {
  const [isViewing, setIsViewing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [viewSheet] = useMutation(MarkMedicationFollowupQuestionnaireSheetDocument);

  const view = useCallback(
    async (sheetId: string) => {
      setIsViewing(true);
      setError(null);

      const queries: InternalRefetchQueryDescriptor[] = (refetchQueries || []).concat([
        {
          query: GetUnreadMedicationFollowupQuestionnaireSheetsDocument,
          variables: { from: BASE_DATE },
        },
      ]);
      try {
        await viewSheet({
          variables: {
            input: {
              medicationFollowupQuestionnaireSheetId: sheetId,
            },
          },
          refetchQueries: queries,
        });
      } catch (error) {
        setError(error?.message || 'エラーが発生しました');
      }
      setIsViewing(false);
    },
    [refetchQueries, viewSheet],
  );

  return {
    isViewing,
    error,
    view,
  };
};
